import classes from './CommonButton.module.css'

const CommonButton = ({text, onClick, className, disabled}) => {
    return(
        <button className={`${classes.wrapper} ${disabled ? classes.disabledButton : ""} ${className}`} onClick={onClick} disabled={disabled}>
            {text}
        </button>
    )
}

export default CommonButton